import React from 'react';
import { Path, Circle, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const DotIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 4 4"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Circle cx="2" cy="2" r="2" fill={color} />
  </Svg>
);

DotIcon.displayName = 'DotIcon';
